<template>
    <section>
        <ScrollObserver
            class="absolute top-4"
            @in-viewport="dropdownSeen = false"
            @not-in-viewport="dropdownSeen = true"
        />
        <Breadcrumbs
            :crumbs="crumbs"
            h2style="text-base at1024:text-xl"
        />
        <Transition name="slide-down">
            <div
                v-if="dropdownSeen"
                class="hidden at1024:flex items-center gap-3 w-full bg-white z-10 fixed top-[var(--header-height)] border-b px-5 py-6 shadow-md"
            >
                <a href="#" class="group">
                    <BaseSvg name="icon-expand-less" class="fill-gray-650 group-hover:fill-red"/>
                </a>
                <div class="flex items-center gap-1">
                    <h2 class="font-bold text-base">{{ $t("Price Books") }}</h2>
                    <span v-if="selectedTag" class="type-tertiary">/</span>
                    <span v-if="selectedTag" class="type-secondary">{{ selectedTag?.name }}</span>
                </div>
            </div>
        </Transition>

        <div class="relative block bg-white w-full at1024:flex justify-center at1024:justify-start items-start at1024:mt-8">
            <span class="shrink-0 hidden at1024:block w-1/5 pl-8">
                <SideNavAlt
                    :sections="tagArray"
                    :click-to-scroll="false"
                    :all="true"
                    v-model="selectedTag"
                    @update:modelValue="setTagSelected"
                    header="Browse by category"
                />
            </span>
            <div class="overflow-hidden at1024:overflow-visible at1024:w-4/5 at1024:pr-8 at1024:pl-12 at1350:pl-16">
                <h1 class="sr-only">Price Books</h1>
                <div v-if="!selectedTag" class="shrink overflow-x-auto">
                    <AlphabetFilter
                        v-model="letterSelected"
                        :available-letters="availableLetters"
                        class="px-4 at1024:px-0 mb-6"
                    />
                </div>
                <div v-else class="p-4 mb-4 bg-gray-125">
                    <BaseSvg name="ArrowForward" aria-label="Category" class="mr-2 -translate-y-px" />
                    <span class="font-bold">{{ selectedTag.name }}</span>
                    <button
                        class="type-secondary hover:type-primary ml-6 underline underline-offset-4"
                        @click="selectedTag = null"
                    >
                        {{ $t("clear") }}
                    </button>
                </div>
                <ul class="w-full block grow-0">
                    <li
                        v-for="manufacturer in filteredManufacturers"
                        class="border-b first-of-type:border-t pb-6 pt-8 relative at1024:flex at1024:items-start at1024:gap-8 at1200:gap-16 at1200:pb-10 at1200:pt-12"
                    >
                        <PriceBookCard :manufacturer="manufacturer" />
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script setup>
import {
    AlphabetFilter,
    BaseSvg,
    Breadcrumbs,
    PriceBookCard,
    ScrollObserver,
    SideNavAlt,
} from "@/Components";
import { computed, ref } from "vue";

const props = defineProps([
    "manufacturers",
    "crumbs",
    "tags",
    "availableLetters",
]);

const selectedTag = ref(null);
const tagArray = ref(props.tags['vendor-category']);
const setTagSelected = (tag) => {
    letterSelected.value = "All";
    selectedTag.value = tagArray.value.filter((t) => t.name === tag)[0];

};

const letterSelected = ref("All");
const dropdownSeen = ref(false);

let filteredManufacturers = computed(() => {
    if (letterSelected.value !== "All") {
        const selectedLetter = letterSelected.value.toLowerCase();
        return props.manufacturers?.data?.reduce((acc, manufacturer) => {
            return manufacturer.name?.toLowerCase().startsWith(selectedLetter)
                ? [...acc, manufacturer]
                : acc;
        }, []);
    }
    if (selectedTag.value) {
        return props.manufacturers?.data?.reduce((acc, manufacturer) => {
            return manufacturer.tag_ids?.includes(selectedTag.value.id)
                ? [...acc, manufacturer]
                : acc;
        }, []);
    }
    return props.manufacturers?.data;
});
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.2s ease-out;
}

.slide-down-leave-to,
.slide-up-enter-from {
    transform: translateY(-100%);
}

.slide-down-enter-from,
.slide-up-leave-to {
    transform: translateY(-100%);
}
</style>
